/* Template: Element link
 ========================================================================== */

template.element_link = function() {
    'use strict';

	$('.element-link').on('click', function (e) {
		
		if (!$(this).find('a.toggle_saved_page, a.toggle_saved_page *').is(e.target)) {
			if ( $(this).find('a:not(.toggle_saved_page)').attr('target') == '_blank' ) {
				window.open($(this).find('a:not(.toggle_saved_page)').attr('href'), '_blank');
			} else {
				window.location = $(this).find('a:not(.toggle_saved_page)').attr('href');
			}
	
			return false;	
		}
	});

};
